import Component from './Component'
import { Title as CardTitle } from './Styles'

export default Component
export const Title = CardTitle
